var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardActionArea = void 0;
var CardActionArea_1 = __importDefault(require("./CardActionArea"));
exports.CardActionArea = CardActionArea_1.default;
exports.default = CardActionArea_1.default;
//# sourceMappingURL=index.js.map